<template>
    <tree-select-input
        ref="searchTreeSelectInput"
        :data-list="categoryList"
        :value="innerValue"
        @select-node="onChange"
        :beforeOnSelect="beforeOnSelect"
        :disabled="disabled"
    ></tree-select-input>
</template>

<script>
import TreeSelectInput from './TreeSelectInput.vue';
import { parseCategoryName, getHost } from './util.js';

/**
 *
 * @author mengqinghui
 * @since 1.3.2
 *
 * 商品品类树形选择框，只支持单选，并且接口是有权限的
 *
 */
export default {
    name: 'XxCategorySelectInput',
    components: {
        TreeSelectInput
    },
    props: {
        /**
         *  初始值categoryId, 支持Number和String
         */
        value: {
            type: [Number, String, Object],
            default: null
        },
        categoryId: {
            type: [Number, String],
            default: ''
        },
        /**
         *  初始值categoryId, 支持String，理论上如果设置初始值，需要categoryId和categoryName都要设置，这块后续版本可以优化
         */
        categoryName: {
            type: String,
            default: ''
        },
        /**
         *  门店Id，主要是获取该门店下的品类，一般不需要设置，注意类型是Number
         */
        poiId: {
            type: Number,
            default: -1
        },
        /**
         *  默认是'请选择分类'
         */
        placeholder: {
            type: String,
            default: '请选择分类'
        },
        /**
         *  可以选中的分类级别，支持Number或者Array，
         *  如果不设置，则是所有的，比如只能选中二级分类，设置为2，如果能选中1，2,3级分类，可以设置为[1,2,3]
         */
        selectLevel: {
            type: [Number, Array]
        },
        /**
         *  可以显示的最大级别，比如显示到第三级分类，设置为3，不设置则显示全部的
         */
        maxLevel: {
            type: Number
        },
        /**
         *  如果设置了selectLevel,该函数在点击其他不应该选中的分类时候触发，函数接受的参数是当前节点{node}
         * 默认情况下会出error的toastr提示
         */
        selectErrorLevel: {
            type: Function,
            default: function(node) {
                this.$message.error(`只能选择${this.selectLevel}级分类,您当前选中的是${node.level}级分类`);
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            categoryList: []
            // innerValue: ''
        };
    },
    watch: {
        categoryId: {
            deep: true,
            handler(newVal) {
                // this.categoryId = newVal;
                if (!newVal) {
                    this.reset();
                }
                return newVal;
            }
        },
        poiId: {
            // immediate: true,
            handler() {
                this.reset();
                this.getAllCategoryList();
            }
        }
    },
    computed: {
        innerValue() {
            if (this.value || this.value !== null) {
                return this.value === -1 ? '' : this.value;
            }
            return this.categoryId + (this.categoryName ? `-${this.categoryName}` : '') || '';
        }
    },
    created() {
        // this.innerValue = this.categoryId + (this.categoryName ? '-' + this.categoryName : '') || '';
        this.getAllCategoryList();
    },
    methods: {
        beforeOnSelect(node) {
            if (this.selectLevel && this.selectLevel !== -1) {
                let levels = Array.isArray(this.selectLevel) ? this.selectLevel : [this.selectLevel];
                if (levels.indexOf(node.level) === -1) {
                    this.selectErrorLevel(node);
                    return false;
                }
            }
            return true;
        },
        onChange(node) {
            let id = '',
                name = '';

            if (node) {
                id = node.id;
                name = node.name;
            }

            // this.innerValue = (id ? id : '') + (name ? '-' + name : '');

            /**
             * change event, 参数是一个node对象.
             *
             * @event change
             * @type {object}
             */

            this.$emit('change', node);

            /**
             * input event, 参数是一个选中节点的id.
             *
             * @event input
             * @type {String}
             */
            this.$emit('input', id);
            this.$emit('change', node);
        },
        getAllCategoryList() {
            let url = `${getHost()}/api/resource/getCategoryList`;
            let body = {
                poiId: this.poiId
            };
            this.$post(url, body)
                .then(data => {
                    let dataTmp = data && data.length ? parseCategoryName(data) : [];
                    let maxLevel = this.maxLevel;
                    if (maxLevel) {
                        dataTmp = dataTmp.filter(i => i.level <= maxLevel);
                    }
                    this.categoryList = dataTmp;
                    // if (
                    //     this.categoryList.findIndex(
                    //         category => +category.id === +this.innerValue
                    //     ) === -1
                    // ) {
                    //     this.reset();
                    // }
                })
                .catch(err => {
                    this.$message({
                        type: 'error',
                        message: err.msg || '获取分类列表失败'
                    });
                });
        },
        /**
         * [重置方法，点击重置按钮的时候可以触发，但是建议通过v-model方式]
         *
         */
        reset() {
            this.$refs.searchTreeSelectInput.$reset();
        }
    }
};
</script>
